<kendo-card [width]="'auto'">
  <div class="k-vbox" *ngIf="circulation">
    <kendo-card-header>
      <h5 kendoCardTitle>{{ (circulation | async)?.props?.title }}</h5>
    </kendo-card-header>
    <hr kendoCardSeparator [orientation]="'vertical'" />
    <kendo-card-body>
      <!-- Owner -->
      <div [ngClass]="(owner | async)?.length > 1 ? 'circ-info-row-owner' : 'circ-info-row' ">
        <div class="circ-info-label"> {{'circ_details_label_owner' | i18n}}: </div>
        <div *ngFor="let user of (owner | async)">
          <circ-person-from-login [login]="user" [showLogin]="false" [showImage]="false">
          </circ-person-from-login>
        </div>
      </div>
      <!-- DueDate -->
      <div class="circ-info-row">
        <div class="circ-info-label"> {{'circ_details_label_enddate' | i18n}}: </div>
        <div>
          <kendo-icon name="calendar" themeColor="primary"></kendo-icon>
          {{ dueDate | async | i18nDate: { date: "medium" } }}
        </div>
      </div>
      <!--Status -->
      <div class="circ-info-row">
        <div class="circ-info-label">{{'circ_details_label_status' | i18n}}:</div>
        <div> {{ ((circulation | async)?.props?.status) | i18nCircStatus }}</div>
      </div>
      <!-- Mail recipients -->
      <div class="circ-info-row">
        <div class="circ-info-label" title="{{ 'circ_details_info_additionalReportRecipients' | i18n }}">{{ 'circ_details_info_additionalReportRecipients_short' | i18n }}:</div>
        <div>
          <kendo-icon name="email" themeColor="primary"></kendo-icon>
          {{ (circulation | async)?.props?.payload?.additionalMailRecipients?.length || 0 }}
        </div>
      </div>
      <!-- Mobil view needed? -->
      <hr kendoCardSeparator *ngIf="(visibleMetadata | async)?.length > 0" class="mb-2 mt-2"/>
      <!-- Visible Metadata -->
      <div class="circ-info-row" *ngFor="let x of (visibleMetadata | async | metadataSort)">
        <div class="circ-info-label"> {{ x.key | i18nMetadata }}: </div>
        <div>
          <div *ngIf="x.settings?.isRequired && !x.value">
            <span
              [ngClass]="['k-icon', 'k-color-error', 'k-i-warning']"
              [title]="'metadata_required' | i18n"
            ></span>
          </div>
          <ng-container [ngSwitch]="x.valueType">
            <div *ngSwitchCase="'date'">
              <!--  For Dates we ignore the DisplayValues and use the technical value, formatted as date. -->
              <div>
                <span>{{ x.value | i18nDate  }}</span>
              </div>
            </div>
            <div *ngSwitchDefault>
              <!-- Render the server-prepared displayValues -->
              <div *ngFor="let v of x.displayValues" [ngSwitch]="x.valueType">
                <div *ngSwitchCase="'link'">
                  <a [href]="v">{{ v | i18nMetadataValue }}</a>
                </div>
                <div *ngSwitchDefault>
                  <span>{{ v | i18nMetadataValue }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- Demand -->
      <hr kendoCardSeparator *ngIf="!!((circulation | async)?.props?.payload?.demand)" class="mb-2 mt-2">
      <div class="circ-info-row">
        <div class="text-pre">{{ (circulation | async)?.props?.payload?.demand }}</div>
      </div>
    </kendo-card-body>
    <hr
      *ngIf="showActionSeparator | async"
      kendoCardSeparator
      class="py-0"
    />
    <kendo-card-actions [layout]="'stretched'" class="circ-actions-wrapper">
      <ece-btn-start
        [attr.circButton]="'default'"
        [title]="'circ_details_button_start' | i18n"
        (click)="emitStart()"
        [disabled]="disableStart | async"
        *ngIf="showStart | async"
      >
        {{ "circ_details_button_start_short" | i18n }}
      </ece-btn-start>
      <hr kendoCardSeparator [orientation]="'vertical'" />
      <ece-btn-delete
        [attr.circButton]="'default'"
        [title]="'circ_details_button_cancel' | i18n"
        (click)="emitCancel()"
        *ngIf="showCancel | async"
      >
        {{ "circ_details_button_cancel_short" | i18n }}
      </ece-btn-delete>
      <hr kendoCardSeparator [orientation]="'vertical'" />
      <ece-btn-edit
        [attr.circButton]="'default'"
        [title]="'circ_details_button_editCirc' | i18n"
        (click)="emitEdit()"
        *ngIf="showEdit | async"
      >
        {{ "circ_details_button_edit_short" | i18n }}
      </ece-btn-edit>
      <hr kendoCardSeparator [orientation]="'vertical'" />
      <ece-btn-icon
        [icon]="'copy'"
        [attr.circButton]="'default'"
        [title]="'circulation_grid_copyCirculation' | i18n"
        (click)="emitCopy()"
        *ngIf="showCopy | async"
      >
        {{ "circulation_grid_copyCirculation" | i18n }}
      </ece-btn-icon>

    </kendo-card-actions>
  </div>
</kendo-card>
